import { render } from "./modalUpdateProfile.vue?vue&type=template&id=492b0bbf&scoped=true"
import script from "./modalUpdateProfile.vue?vue&type=script&lang=js"
export * from "./modalUpdateProfile.vue?vue&type=script&lang=js"

import "./modalUpdateProfile.vue?vue&type=style&index=0&id=492b0bbf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492b0bbf"]])

export default __exports__